export default __webpack_public_path__ + "static/media/campaign-placeholder.7df77b00.png";